import Api from '@/api';
import _ from 'lodash';
import * as types from '../mutation-types';

const state = {
  checkoutIds: [],
  orders: [],
};

const getters = {
  // getOrderById: s => id => _.find(s.orders, { id }),
  unpaidOrders: s => _.filter(s.orders, o => o.payment_status === 0),
  shippingOrders: s => _.filter(s.orders, o => o.status === 4),
  unpickupOrders: s => _.filter(s.orders, o => o.status === 4 && o.shipping.pickup_code),
  uncommentOrders: s => _.filter(s.orders, o => o.status === 6 && o.comments.length !== s.products.length),
  completedOrders: s => _.filter(s.orders, o => o.status === 6),
  closedOrders: s => _.filter(s.orders, o => o.status === 5),
};

const actions = {
  setCheckoutIds({ commit }, ids) {
    commit(types.SET_CHECKOUT_IDS, ids);
  },
  fetchOrders({ commit }) {
    return Api.order.get().then(({ data: response }) => {
      commit(types.RECEIVE_ORDERS, response.data);
    });
  },
  submitOrder({ commit, dispatch }, params) {
    return Api.order.submit(params).then(({ data: response }) => {
      dispatch('getCart');
      commit(types.NEW_ORDER, response.data);
      return response.data;
    });
  },
  deleteOrder({ commit }, id) {
    return Api.order.delete(id).then((response) => {
      if (response.status === 204) {
        commit(types.DELETE_ORDER, id);
      }
    });
  },
};
/* eslint no-param-reassign: 0 */
const mutations = {
  [types.SET_CHECKOUT_IDS](s, ids) {
    s.checkoutIds = [...ids];
  },
  [types.RECEIVE_ORDERS](s, data) {
    s.orders = [...data];
  },
  [types.EMPTY_ORDERS](s) {
    s.orders = [];
  },
  [types.NEW_ORDER](s, data) {
    s.orders = [data, ...s.orders];
  },
  [types.DELETE_ORDER](s, id) {
    s.order = _.reject(s.order, item => item.id === id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
